module.exports = __webpack_public_path__ + "24b5416259c467ca18ebf04597ce8c9b.jpg";